import { DateTime } from '@cheqroom/date-time';
import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

interface MeResponse {
	_id: string;
	userMe: {
		_id: string;
		name: string;
	};
}

interface MeResponse {
	profile: {
		acceptedTerms: boolean | null;
	};
}

export const getHasUserAcceptedTerms = async (userId: string, accessToken: string): Promise<boolean | null> => {
	const response = await fetch(
		`${process.env.API_URL as string}/${userId}/null/jwt/users/call/me?_fields=profile.acceptedTerms`,
		{
			method: 'GET',
			headers: { 'Content-Type': 'application/json', authorization: `Bearer ${accessToken}` },
		}
	);

	if (!response.ok) {
		throw new Error('Something went wrong');
	}

	const jsonResponse = (await response.json()) as Promise<MeResponse>;

	return (await jsonResponse).profile.acceptedTerms;
};

export const useAcceptTermsOfUse = (
	options?: UseMutationOptions<unknown, unknown, { userId: string; accessToken: string }, unknown>
): UseMutationResult<unknown, unknown, { userId: string; accessToken: string }, unknown> => {
	return useMutation<unknown, unknown, { userId: string; accessToken: string }, unknown>(
		['accept-terms-of-use'],
		async ({ userId, accessToken }) => {
			const utcNow = DateTime.now().withZone('utc', { keepLocalTime: true }).toISOString();

			const response = await fetch(
				`${process.env.API_URL as string}/${userId}/null/jwt/users/${userId}/call/updateProfile?acceptedTerms=${utcNow}`,
				{
					method: 'GET',
					headers: { 'Content-Type': 'application/json', authorization: `Bearer ${accessToken}` },
				}
			);

			if (!response.ok) {
				throw new Error('Something went wrong');
			}

			return response.json();
		},
		options
	);
};
